export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-10.dc55dc76.png";